import React, { useEffect, useState } from 'react';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';

export const LoggedInUser = () => {
  const identityApi = useApi(identityApiRef);
  const [userId, setUserId] = useState('');

  useEffect(() => {
    identityApi.getBackstageIdentity().then(identity => {
      setUserId(identity.userEntityRef);
    });
  }, [identityApi]);
  const url=`https://dock.dh.lufthansa-group.com/catalog/default/user/${userId?.replace('user:default/', '')}/copilot-compliance`;

  return <div>Check your eligibility and compliance status in <a href={url} target="_blank" rel="noopener noreferrer" style={{color:'blue'}}>DH-Dock</a></div>;
};